import type {
  AdChannelTypeEnum,
  AdUnitAndDetailsSummaryDtoCalculationsInline,
  ExistingCustomersState,
  IdPostCampaignDto,
  LanguageRegion,
  PostCampaignStatus,
} from '@/services/ws-post/src/main/resources/rest-api';

import type { MAILING_CHANNELS } from './constants';

export type DeliveriesByLanguageMap = {
  [key in LanguageRegion]?: number;
};

export interface PostCampaignRouteParams {
  campaignId?: IdPostCampaignDto;
  status: PostCampaignStatus;
}

export enum PostPositionType {
  Digital = 'DIGITAL',
  UnaddressedMailing = 'UNADDRESSED_MAILING',
  Service = 'SERVICE',
  Email = 'EMAIL',
  AddressedMailing = 'ADDRESSED_MAILING',
  Discount = 'DISCOUNT',
  Online = 'ONLINE',
}

export enum Step {
  GENERAL = 'general',
  CONFIGURE_POSITIONS = 'configurePositions',
  PREVIEW = 'preview',
  INFORMATION = 'information',
  CALCULATION = 'calculation',
  TARGET_GROUP_SETTINGS = 'targetGroupSettings',
}

export type MailingChannel = (typeof MAILING_CHANNELS)[number];

export interface SavedPostCampaignRouteParams {
  status: PostCampaignStatus;
  campaignId: IdPostCampaignDto;
}

export interface ChannelSummaryValues {
  reach: number;
  percentage: number;
  netAmount: number;
  count?: number;
}

export type SummaryPerChannel = {
  [Key in AdChannelTypeEnum]?: ChannelSummaryValues;
};

export interface SummaryValues {
  grossAmount: number;
  percentageDiscount: number;
  discountAmount: number;
  netAmount: number;
  summaryPerChannel: SummaryPerChannel;
  calculations: AdUnitAndDetailsSummaryDtoCalculationsInline;
  existingCustomersState?: ExistingCustomersState;
}

export enum DiscountPositionName {
  DiscountPosition = 'DISCOUNT_POSITION',
}
